import { useEffect, useRef, useState } from 'react';

interface Props<T> {
  Component: React.VFC<T>;
  props: T;
  triggerRef: React.RefObject<HTMLElement>;
  isHidden: boolean;
}

const DelayedDisappearance = <T extends JSX.IntrinsicAttributes>({
  Component,
  props,
  triggerRef,
  isHidden,
}: Props<T>) => {
  const ref = useRef<JSX.Element | null>(null);
  const [isReady, setIsReady] = useState(isHidden);

  useEffect(() => {
    triggerRef.current?.addEventListener('transitionend', () => setIsReady(true));
  }, [triggerRef]);

  useEffect(() => {
    if (isHidden) {
      setIsReady(false);
    }
  }, [isHidden]);

  if (isHidden) {
    return isReady ? null : ref.current;
  }

  return (ref.current = <Component {...props} />);
};

export { DelayedDisappearance };
